"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationType = void 0;
var AuthenticationType;
(function (AuthenticationType) {
    AuthenticationType["WebLogin"] = "webLogin";
})(AuthenticationType = exports.AuthenticationType || (exports.AuthenticationType = {}));
